import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  viewChild,
} from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { finalize, first } from "rxjs/operators";
import {
  CONFIRM_DIALOG_MESSAGE,
  CONFIRM_DIALOG_MESSAGE_DELETE,
} from "../../locale/consts.en";
import { ItemEditComponent } from "../item-edit/item-edit.component";
import { MasterDataService } from "../master-data/master-data-service";
import { FormType } from "../master-data/master-data.model";
import {
  ConfDialogType,
  ConfirmDialogModel,
} from "../shared/confirm-dialog/confim-dialog.model";
import { ConfirmDialogComponent } from "../shared/confirm-dialog/confirm-dialog.component";
import { sortByStringWithEmptyAtEnd } from "../shared/helpers/helper-functions";

@Component({
  selector: "app-form-types",
  templateUrl: "./form-types.component.html",
  styleUrls: ["./form-types.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormTypesComponent implements OnInit, AfterViewInit {
  private dialog = inject(MatDialog);
  private masterDataService = inject(MasterDataService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private fb = inject(FormBuilder);

  formtypes: FormType[] = [];
  formtypesForm = this.fb.group({
    name: [null, [Validators.required]],
    externalId: [null],
  });
  readonly sort = viewChild(MatSort);
  dataSource: MatTableDataSource<FormType>;
  displayedColumns: string[] = ["name", "externalId", "edit", "delete"];

  ngOnInit(): void {
    const formtypes = this.route.snapshot.data.formtypes ?? [];
    this.formtypes = sortByStringWithEmptyAtEnd(formtypes, (item) => item.name);
    // this.formtypes = this.route.snapshot.data.formtypes.sort((a, b) =>
    //   a.name.localeCompare(b.name)
    // );
    this.dataSource = new MatTableDataSource(this.formtypes);
    console.log("Snap data", this.route.snapshot.data);
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  saveFormTypeToApi(ft: FormType) {
    this.masterDataService
      .updateFormType(ft)
      .pipe(
        finalize(() => {
          this.masterDataService
            .getFormTypes()
            .pipe(first())
            .subscribe((formtypes) => {
              this.formtypes = formtypes;
              this.dataSource.data = this.formtypes;
            });
        }),
      )
      .subscribe({
        next: (response) => {
          this.masterDataService.handleResponse(response);
        },
        error: (err) => this.masterDataService.savingErrorMessage(),
      });
  }

  updateFormType(d: FormType) {
    const priority = new FormType();
    Object.assign(priority, d);
    const dialogRef = this.dialog.open(ItemEditComponent, {
      width: "20vw",
      data: priority,
    });
    dialogRef.afterClosed().subscribe(async (data: FormType) => {
      if (data != null) {
        this.saveFormTypeToApi(data);
      }
    });
  }

  deleteFormType(formtype: FormType) {
    const dialogData = new ConfirmDialogModel(
      CONFIRM_DIALOG_MESSAGE,
      CONFIRM_DIALOG_MESSAGE_DELETE,
      ConfDialogType.MESSAGE,
    );
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
  }

  onAddFormType() {
    const formtype = new FormType();
    const dialogRef = this.dialog.open(ItemEditComponent, {
      width: "20vw",
      data: formtype,
    });
    dialogRef.afterClosed().subscribe(async (data: FormType) => {
      if (data != null) {
        this.saveFormTypeToApi(data);
      }
    });
  }

  onBack() {
    this.router.navigate(["/"]).then();
  }
}
